export default "__VITE_PUBLIC_ASSET__6e7ec7ac__"